export const COUPON_QUERY_ROOT = "coupons";

export const couponQueryKeys = {
  activeList: () => [COUPON_QUERY_ROOT, "activeList"],
  detail: (couponCode) => [COUPON_QUERY_ROOT, "detail", couponCode?.trim() ?? ""],
  scopeVerticals: () => [COUPON_QUERY_ROOT, "scope", "verticals"],
  scopeCurrencies: () => [COUPON_QUERY_ROOT, "scope", "currencies"],
  scopeTenants: (verticalId) => [
    COUPON_QUERY_ROOT,
    "scope",
    "tenants",
    String(verticalId ?? "").trim(),
  ],
  packagesByTenants: (tenantIds = []) => [
    COUPON_QUERY_ROOT,
    "packages",
    "tenants",
    [...tenantIds].map(String).sort().join(","),
  ],
};
